import * as types from '../types/faqTypes';
import * as faqServices from '../../services/faqServices';

export const fetchFaqs = () => async (dispatch) => {
  dispatch({ type: types.FETCH_FAQ_LIST_REQUEST });
  try {
    const response = await faqServices.getFaqs();
    dispatch({ type: types.FETCH_FAQ_LIST_SUCCESS, payload: response });
  } catch (error) {
    const message = error.response?.data?.message || error.message || 'Failed to fetch FAQs';
    dispatch({ type: types.FETCH_FAQ_LIST_FAILURE, payload: message });
  }
};

